import { Home } from "lucide-react";
import { useEnabledManifests } from "../registry";
import type { NavItem } from "../types";

export interface ResolvedNavItem extends NavItem {
  id: string;
}

const HOME: ResolvedNavItem = { id: "home", label: "Home", href: "/dashboard", icon: Home, order: 0 };

/**
 * Home plus one destination per enabled feature with a navItem. Empty when no
 * feature has one, so the nav disappears entirely with the features off.
 */
export function useNavItems(): ResolvedNavItem[] {
  const manifests = useEnabledManifests();
  const items = manifests.flatMap((m) => (m.navItem ? [{ id: m.id, ...m.navItem }] : []));
  if (items.length === 0) return [];
  return [HOME, ...items].sort((a, b) => a.order - b.order);
}

/** Pages that belong to a destination without living under its path. */
const ALSO_ACTIVE: Record<string, readonly string[]> = {
  home: ["/wins", "/partners", "/sim/partner-analytics"],
  community: ["/settings/community"],
  shop: ["/settings/recommendations"],
};

export function isNavActive(item: ResolvedNavItem, path: string): boolean {
  if (ALSO_ACTIVE[item.id]?.includes(path)) return true;
  if (item.id === "home") return path === "/dashboard" || /^\/child\/(?!new)/.test(path);
  return path === item.href || path.startsWith(`${item.href}/`);
}
